<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden">
  <app-ion-common-label
    [id]="idLabelPep"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Você é uma Pessoa Exposta Politicamente?"
  >
  </app-ion-common-label>

  <div class="text-rg mt-lg">
    <p class="text-space">
      Consideram-se pessoas politicamente expostas os agentes públicos que
      desempenham ou tenham desempenhado, nos cinco anos anteriores, no Brasil
      ou em países, territórios e dependências estrangeiras, cargos, empregos ou
      funções públicas relevantes, assim como seus representantes, familiares e
      estreitos colaboradores.
    </p>
  </div>

  <div class="control-page">
    <app-ion-common-button
      [id]="idButtonPepYes"
      label="Sim"
      typeButton="light"
      positionButton="block"
      (clickButton)="clickNext(true)"
    ></app-ion-common-button>
    <div class="border-top">
      <app-ion-common-button
        [id]="idButtonPepNo"
        label="Não"
        typeButton="light"
        positionButton="block"
        (clickButton)="clickNext(false)"
      ></app-ion-common-button>
    </div>
  </div>
</ion-content>
